/**
 * wishlistPage — Componente Alpine per la pagina wishlist.
 *
 * Gestisce: invio email, svuota tutto, rimozione live dei corsi.
 *
 * Uso nel template:
 *   <div x-data="wishlistPage">
 */
export function registerWishlistPage(Alpine) {
    Alpine.data('wishlistPage', () => ({
        // Email
        showEmailForm: false,
        email: '',
        sending: false,
        emailSent: false,
        emailError: '',

        // Modal conferma svuota
        showClearModal: false,

        init() {
            // Inizializza lo store con i dati SSR
            const grid = this.$refs.grid;
            if (grid) {
                const cards = grid.querySelectorAll('.ik-course-card');
                this.$store.wishlist.count = cards.length;
                this.$store.wishlist._syncCookie();
            }

            // Registra IDs dei corsi in wishlist nello store
            document.querySelectorAll('.ik-wishlist-toggle[data-in-wishlist]').forEach(btn => {
                const courseId = parseInt(btn.dataset.courseId, 10);
                if (courseId) {
                    this.$store.wishlist.trackId(courseId);
                }
            });
        },

        /**
         * Invia wishlist per email.
         */
        async sendEmail() {
            if (!this.email || this.sending) return;

            this.sending = true;
            this.emailSent = false;
            this.emailError = '';

            try {
                await this.$store.wishlist.sendEmail(this.email);
                this.emailSent = true;
                this.email = '';
                // Nascondi messaggio successo dopo 5 secondi
                setTimeout(() => { this.emailSent = false; }, 5000);
            } catch (e) {
                this.emailError = e?.detail || e?.message || 'Errore durante l\'invio. Riprova.';
            } finally {
                this.sending = false;
            }
        },

        /**
         * Apre il modal di conferma svuota wishlist.
         */
        clearAll() {
            this.showClearModal = true;
        },

        /**
         * Conferma svuota wishlist (chiamato dal modal).
         */
        async confirmClear() {
            this.showClearModal = false;

            try {
                await this.$store.wishlist.clear();
            } catch (e) {
                console.error('wishlistPage.confirmClear:', e);
                return; // Rollback già fatto nello store
            }

            // Rimuovi tutte le card dalla griglia
            const grid = this.$refs.grid;
            if (grid) {
                grid.innerHTML = '';
            }

            // Forza aggiornamento reattivo
            this.$store.wishlist.count = 0;
        },
    }));
}
